/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'
import { Button, Tooltip, Box, useTheme } from '@mui/material'

export const useTableModel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons 
      baseUrl={'/rti-concerns/'} params={row?.sid ? [{k: 'student_id', v: row.sid}] : []} row={row} />,
    [],
  )

  const handleNameFormat = useCallback((cellValue: string, row: any) => {
    return <Box onClick={ () => navigate(`/rti-students/${row.student_id}#reasons`) } sx={{ cursor: 'pointer', '&:hover': {
      color: 'red'
    } }}>{cellValue}<br/>{row.student_academic_id && "#"+row.student_academic_id}</Box>
  }, [])

  const columns: IColumn[] = [
    {
      title: `${t('common.groups')}`,
      field: 'student_groups',
      order: false,
      width: '10%',
    },
    {
      title: `${t('common.student')}`,
      field: 'student_name',
      order: false,
      width: '20%',
      format: handleNameFormat,
    },
    {
      title: `${t('rti.environmental-conditions-or-task-demands')}`,
      field: 'task_demands',
      order: false,
      width: '20%',
    },
    {
      title: `${t('rti.problem-description')}`,
      field: 'problem_description',
      order: false,
      width: '20%',
    },
    {
      title: `${t('rti.expected-level-of-performance')}`,
      field: 'expected_performance',
      order: false,
      width: '20%',
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}
